export default __webpack_public_path__ + "static/media/logo-text.d270e016.png";